<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !addPriceVisible">
      <div class="filter-container">
          <div class="filter-box">
            <span class="label">名称</span>
            <el-input
                v-model="listQuery.name"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">品牌</span>
            <el-input
                v-model="listQuery.brand"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
                v-model="listQuery.model"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">代码</span>
            <el-input
                v-model="listQuery.code"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">参数</span>
            <el-input
                v-model="listQuery.parameter"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">物料类别</span>
            <el-select :filterable="true" v-model="listQuery.materialClassId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in materialClassOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
              <el-button
                  v-waves
                  class="filter-item "
                  type="primary"
                  :size="t('table.btnSize')"
                  @click="handleFilter"
              >
                  {{ t("table.search") }}
              </el-button>
              <el-button
                v-permission="{ pkey: `${permissionName}_ADD` }"
                class="filter-item"
                type="primary"
                :size="t('table.btnSize')"
                @click="handleCommand('add')"
              >
                {{ t("table.add") }}
              </el-button>
              <el-button
                  v-waves
                  class="filter-item"
                  :size="t('table.btnSize')"
                  @click="handleReset"
              >
                  {{ t("table.reset") }}
              </el-button>
              <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
                <i class="icon-tubiao-27 iconfont"/>
              </span>
              <span class="svg-icon cursor" @click="handleCommand('column')">
                <i class="icon-tubiao-28 iconfont"/>
              </span>
          </div>
      </div>
      <grid-layout
        v-model:layout="layouts"
        :col-num="12"
        :row-height="rowHeight"
        :is-draggable="false"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="false"
      >
        <grid-item
          v-for="(item, index) in layouts"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          :minW="item.minW"
          :maxW="item.maxW"
          :minH="item.minH"
          :static="item.static"
          @resize="handleResizedEvent"
          @resized="handleResizedEvent">
          <template v-if="index === 0">
            <TableList
              :ref="rf => { if (rf) tableDataRef[index] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="false"
              :isShowPagination="false"
              :handleDefaultWidth="120"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              style="height:calc(100% );overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:max="scope" >
                <span>
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    v-if="scope.row.max"
                  >
                    <template #content> {{scope.row.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.max?.updateTime}}</template>
                    <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
                  </el-tooltip>
                  {{ maxMinCalc(scope.row, 'max') }}
                </span>
              </template>
              <template v-slot:min="scope" >
                <span>
                  <el-tooltip
                    effect="dark"
                    placement="top-start"
                    v-if="scope.row.min"
                  >
                    <template #content> {{scope.row.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.min?.updateTime}}</template>
                    <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
                  </el-tooltip>
                  {{ maxMinCalc(scope.row, 'min') }}
                </span>
              </template>
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
          </template>
          <!-- <template v-if="index === 1">
            <div v-show="!isSubMenuCollapse">
              <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{'active':activeTab===item.id}" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
              </div>
              <PriceInfo v-if="activeTab===1" ref="PriceInfo" :id="activeId" formPage="material" :dataId="activeId"/>
            </div>
          </template> -->
        </grid-item>
      </grid-layout>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="pathApi"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <FormComponent
      v-if="addPriceVisible"
      :id="0"
      :initFormData="initPriceFormData"
      :fromFieldData="fromPriceFieldData"
      :dialogFormVisible="addPriceVisible"
      api="materialInquiry"
      @update:visibel="addPriceVisible = false"
      @submit="handleSubmit(formData)"
    >
      <template v-slot:front>
        <MateriallDescription :detail="activeRow"/>
      </template>
    </FormComponent>
    <el-dialog
      v-model="priceVisible"
      title="价格信息"
      width="80%"
      append-to-body
      :close-on-click-modal="false"
    >
      <div style="overflow:auto;height:600px">
        <PriceInfo
          ref="PriceInfo"
          :id="activeId"
          formPage="material"
          :dataId="activeId"
          :isShowAdd="false"
          :isEditInDialog="true"
          :materialInfo="activeRow"
        />
      </div>
    </el-dialog>
    <!-- <el-button type="primary" circle  @click="handleSubMenuCollapse" class="subMenuCollapseBtn"  v-if="!dialogFormVisible&&!addPriceVisible"> {{isSubMenuCollapse?'展开':'收起'}}</el-button> -->
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList } from '@/apis/Dictionary'

import { PaymentAccountModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import PriceInfo from '@/views/purchasManage/purchaseInAdvance/priceInfo/Index.vue'
import { FromFieldData as priceFromFieldData } from '@/views/purchasManage/purchaseInAdvance/priceInfo/FieldFrom'

import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField, maxMinCalc } from './FieldTable'
import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import { pageVo, pageSizes } from '@/utils/index'
import CommandRender from '@/components/common/CommandRender.vue'
import MateriallDescription from './MateriallDescription.vue'

export default defineComponent({
  name: 'Materialinfo',
  components: {
    FormComponent,
    TableList,
    PriceInfo,
    CommandRender,
    MateriallDescription
  },
  props: {
    excludeIds: { type: Array, required: false, default: () => [] }
  },
  setup(props) {
    const { t } = useI18n()
    const PriceInfo = ref(null)
    const tableDataRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_MATERIALINFO,
      permissionName: permissionName.MATERIALINFO,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      initPriceFormData: cloneDeep(priceFromFieldData),
      fromPriceFieldData: priceFromFieldData,
      columnAllData: TableField,
      pathApi: 'material',
      activeId: 0,
      activeRow: {} as any,
      maxMinCalc,
      list: [],
      materialClassOption: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      pageSizes,

      tabList: [
        { name: '价格信息', id: 1 }
      ],
      activeTab: 1,
      newHpx: 0,
      btnList: [],
      priceVisible: false,
      addPriceVisible: false,
      handleCommand(command: string, val?: any) {
        if (command !== 'column') {
          dataMap.activeId = val ? val.id : 0
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'add-price':
            dataMap.activeRow = val
            dataMap.handlePriceCreate()
            break
          case 'price-info':
            dataMap.activeRow = val
            dataMap.priceVisible = true
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabCommand(command: string) {
        if (this.activeTab === 1) {
          if (PriceInfo.value && PriceInfo.value) {
            ;(PriceInfo.value as any).handleCommand(command)
          }
        }
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      getList() {
        dataMap.listLoading = true
        getPageList(dataMap.pathApi, {
          ...dataMap.listQuery,
          excludeIds: props.excludeIds
        }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      handlePriceCreate() {
        dataMap.initPriceFormData.forEach((k: any) => {
          k.formList.forEach((formList: any) => {
            formList.list.forEach((field: any) => {
              if (field.fieldKey === 'materialId') {
                field.value = dataMap.activeId
              }
            })
          })
        })
        dataMap.fromPriceFieldData = cloneDeep(dataMap.initPriceFormData)
        dataMap.addPriceVisible = true
      },
      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getDetailById(dataMap.pathApi, row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey]
                if (field.fieldKey === 'images') {
                  field.value = res[field.fieldKey] ? res[field.fieldKey].split(',') : []
                }
              })
            }
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById(dataMap.pathApi, row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getMaterialClassOption() {
        getPageList('materialClass', { page: 1, size: 999 }).then((res: any) => {
          dataMap.materialClassOption = res.data || []
        })
      }
    })
    const { mixinData } = mixin(dataMap)
    onMounted(() => {
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit'
        },
        {
          pkey: 'MATERIAL_PRICE_INFO_EDIT',
          name: '询价',
          command: 'add-price'
        },
        {
          pkey: 'MATERIAL_PRICE_INFO_LIST',
          name: '价格信息',
          command: 'price-info'
        },
        {
          pkey: `${dataMap.permissionName}_DELETE`,
          name: '删除',
          type: 'danger',
          command: 'delete'
        }
      ]
      mixinData.initHeight()
      dataMap.getList()
      dataMap.getMaterialClassOption()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableDataRef }
  }
})
</script>
<style  lang="scss">

</style>
